import { RouteModule } from '#/horizon/components/RouteModule';
import type { LoaderDataWithOverrideLocale } from '#/horizon/useMatchesOverrideLocale';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { salariesSurveyRoute } from '#/modules/salaries/routing/salaries.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { getStaticImageSrc } from '#/utils/getImageSrc';

import { CompensationSurveyPageLoadable } from './CompensationSurveyPageLoadable';

export const handle = {
  variant: 'base',
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof salariesSurveyRoute>,
) {
  await CompensationSurveyPageLoadable.load();

  return {
    overrideLocale: I18nLocale.EN,
  } satisfies LoaderDataWithOverrideLocale;
}

export default function CompensationSurveyHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return (
    <RouteModule
      title="Idealist"
      ogImage={getStaticImageSrc('compdb/og-image.png')}
    >
      <CompensationSurveyPageLoadable />
    </RouteModule>
  );
}
